import { Docorga } from '@docorga-v1/docorga-common';
import pkg from '../package.json';
import { IEnvironmentConf } from './environment.interface';

const domain = 'dcrg.dev';
const appEnv = Docorga.enums.environments.EnvironmentsName.SANDBOX;

export const environment: IEnvironmentConf = {
  appEnv,
  production: true,
  version: pkg.version,
  domain,

  adminUrl: `https://v1.${appEnv}.admin.${domain}/`,
  mobileUrl: `https://v1.${appEnv}.mobile.${domain}/`,
  praticienUrl: `https://v1.${appEnv}.praticien.${domain}/`,
  prlUrl: `https://v1.${appEnv}.prl.${domain}/`,
  keycloakUrl: `https://${appEnv}.auth.${domain}/`,
  keycloakRealm: appEnv,

  // TODO: white list
  whiteListedDomains: [''],

  showcaseUri: 'https://pro.docorga.com/',
  stripePublicKey: 'pk_live_WMuiDfjBrVVokoNpOURZVsHG',

  azureBlobUrl: 'https://docorgatest.blob.core.windows.net',
  externalGoogleRecaptchaId: '6Lfv_s8qAAAAAD816UylF6r9GQdVLOwuefW1wQfC'
};
